module.exports = __webpack_public_path__ + "images/emoji/surfer.58f4e48047002305b31b.png";